export default __webpack_public_path__ + "static/media/BackArrowIcon.29a12d37.svg";